import gql from 'graphql-tag';
import {EditorialTagFullFragment} from "../fragments/EditorialTagFullFragment";

export const EditorialTagEditQuery = gql`
	query EditorialTagEditQuery($id: ID!) {
		entity: node (id: $id) {
				...EditorialTagFullFragment
		  }
	}
	${EditorialTagFullFragment}
`;


